import { Modal, Table } from 'antd';
import { FC, useEffect, useState } from 'react';

/**
 * @Description 操作历史详情弹窗
 */
const HistoryModal:FC<{detail, setDetail}> = ({ detail, setDetail }) => {
  const [data, setData] = useState<any[]>([]);
  const columns = [
    { dataIndex: 'field', title: '编辑字段', width: 160 },
    { dataIndex: 'original', title: '编辑前', width: 160, render: (val) => val || '-' },
    { dataIndex: 'current', title: '编辑后', width: 160, render: (val) => val || '-' },
  ];

  useEffect(() => {
    if (detail?.visible && detail.content) {
      setData(detail.content || []);
    }
  }, [detail]);
  return (
    <Modal
      open={detail.visible}
      onCancel={() => setDetail({ visible: false, content: null })}
      footer={false}
      title='操作详情'
      width={613}
      centered>
      <Table
        scroll={{ y: '70vh' }}
        columns={columns}
        dataSource={data}
        bordered
        pagination={false}/>
    </Modal>
  );
};

export default HistoryModal;
